import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

export const TravelersFormDataContext = React.createContext({
  travelersFormData: {},
  setTravelersFormData: () => {},
});

const TravelersFormProvider = props => {
  const [travelersFormData, setTravelersFormData] = useState({});

  const contextValue = useMemo(() => {
    return {
      travelersFormData,
      setTravelersFormData,
    };
  }, [travelersFormData, setTravelersFormData]);

  if (
    typeof window !== 'undefined' &&
    !(window.location.pathname.split('/')[3] === 'travelers') &&
    travelersFormData
  ) {
    setTravelersFormData(null);
  }

  return (
    <TravelersFormDataContext.Provider value={contextValue}>
      {props.children}
    </TravelersFormDataContext.Provider>
  );
};

TravelersFormProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TravelersFormProvider;

export const TravelersFormContext = () => {
  const { setTravelersFormData } = useContext(TravelersFormDataContext);
  const { values } = useFormikContext();
  const travelersFormRef = useRef(null);

  useEffect(() => {
    travelersFormRef.current = values;
  });

  useEffect(() => {
    return () => {
      setTravelersFormData(travelersFormRef.current);
    };
  }, [setTravelersFormData]);

  return null;
};
